import { gql } from '@apollo/client';

export default class ColumnSettingsMutation {
    static SAVE_COLUMN_SETTINGS_BY_TABLE = gql`
        mutation saveColumnSettingsByTable($module: String!, $tableName: String!, $columns: [columnInput]!) {
            saveColumnSettingsByTable(module: $module, tableName: $tableName, columns: $columns)
        }
    `;
}
